module.exports = __webpack_public_path__ + "img/ai-bibi.62f308d.svg";